<ng-content></ng-content>
@if (showChevron) {
<button data-testid="button-chevron-line" type="button" mat-icon-button class="fs-16 cursor-pointer" (click)="toggleEvent.emit()">
  <mat-icon class="fs-24" [ngClass]="isExpanded ? 'is-expanded' : ''"> expand_more </mat-icon>
</button>
}
